import { call, put, takeLatest } from "redux-saga/effects"

import { GET_LIST_MULTIPLE_CHOICE_QUESTIONS_WATCHER } from "./constants"

import {
  getListMultipleChoiceQuestionsSuccess,
  getListMultipleChoiceQuestionsFailed,
} from "./actions"
import { getListMultipleChoiceQuestionsApi } from "../../../utils/routes/routes-report"

export function* getListMultipleChoiceQuestionsSaga(action) {
  try {
    const dataStatus = action.payload
    const { data: listMultipleChoiceQuestions } = yield call(
      getListMultipleChoiceQuestionsApi,
      dataStatus
    )
    yield put(
      getListMultipleChoiceQuestionsSuccess(listMultipleChoiceQuestions)
    )
  } catch (e) {
    yield put(getListMultipleChoiceQuestionsFailed())
  }
}

// Individual exports for testing
export default function* widgetMultipleChoiceQuestions() {
  yield takeLatest(
    GET_LIST_MULTIPLE_CHOICE_QUESTIONS_WATCHER,
    getListMultipleChoiceQuestionsSaga
  )
}
